import { useEffect, useState } from 'react';
import { api } from '@/api/client';

// Cache the currency symbol globally so we don't re-fetch
let _currencyCache = null;
const subscribers = new Set();

const notify = (val) => {
  _currencyCache = val;
  subscribers.forEach(fn => fn(val));
};

export const refreshCurrency = async () => {
  try {
    const res = await api.getSettings();
    const c = res.data?.currency || 'LKR';
    notify(c);
    return c;
  } catch (e) {
    notify('LKR');
    return 'LKR';
  }
};

/**
 * useCurrency returns the configured currency symbol (e.g. "LKR", "$", "Rs.").
 * Defaults to "LKR" before settings load.
 */
export const useCurrency = () => {
  const [currency, setCurrency] = useState(_currencyCache || 'LKR');

  useEffect(() => {
    if (_currencyCache === null) {
      refreshCurrency();
    }
    subscribers.add(setCurrency);
    return () => subscribers.delete(setCurrency);
  }, []);

  return currency;
};

/**
 * Format a number as currency: "LKR 1,000.00"
 */
export const formatCurrency = (amount, currency = 'LKR') => {
  const num = Number(amount || 0);
  const formatted = new Intl.NumberFormat('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }).format(num);
  // For symbol-style currencies like $ £ €, no space. For codes like LKR/USD, add a space.
  const isSymbol = /^[^\w]/.test(currency.trim());
  return isSymbol ? `${currency}${formatted}` : `${currency} ${formatted}`;
};
